<template>
    <div class="p-3 bg-white shadow-sm">
        <a href="" class="btn btn-info btn-sm float-right" :disabled="wait" @click.prevent="clearNotifications()">Clear
            Notifications</a>
        <h4 class="font-weight-bold text-success">Notifications</h4>

        <br>
        <alerts :_error="error" :_success="success"></alerts>

        <div v-if="notifications.data==0" class="border rounded-lg text-muted font-weight-bold p-2">
            You have zero notifications
        </div>

        <div class="d-flex flex-wrap justify-content-between mb-3" style="column-gap: 1%;">
            <div v-for="i in notifications.data" :key="i.id" class="rounded-lg p-2 notification mb-2"
                 :class="i.read_at ? 'text-muted' : ''">
                <div class="font-weight-bold mb-2">{{ day(i.created_at).format('MMM, DD H:mm A') }}</div>
                <div>{{ i.data.message }}</div>

                <div class="text-muted mt-2">
                    <a href="#" v-if="!isRead(i)" @click.prevent="markAsRead(i)"
                       class="highlight"
                       :disabled="reading && selected_id === i.id">
                        <template v-if="reading && selected_id === i.id"><b>Wait...</b></template>
                        <template v-else>Mark as read</template>
                    </a>
                    <small v-else class="text-muted mr-1">Seen {{ day(i.read_at).format('MMM, DD H:mm') }}</small>&nbsp;


                    <a href="#" @click.prevent="clearNotifications(i)" class="highlight text-info"
                       :disabled="reading && selected_id === i.id">
                        <template>Clear</template>
                    </a>

                    <span class="float-right">{{ day(i.created_at).format('MMM, DD H:mm') }}</span>

                </div>

            </div>
        </div>

        <pagination :limit="1" :data="notifications"
                    @pagination-change-page="loadNotifications"></pagination>

    </div>
</template>

<script>
import Alerts from "@/components/Alerts";

export default {
    name: "Notifications",
    components: {Alerts},
    data() {
        return {
            reading: false,
            selected_id: '',
            notifications: {data: []}
        }
    },
    mounted() {
        this.loadNotifications()
    },
    methods: {
        isRead(i) {
            return (i.read_at != null)
        },
        clearNotifications(record) {
            if (confirm('Clear notification?')) {
                this.success = 'Please wait...'
                let url = record ? '/notifications/clear?id=' + record.id : '/notifications/clear'
                this.$http.get(url).then(() => {
                    this.loadNotifications()
                    this.success = ''
                    this.$emit('reloadNotificationCount')
                }).catch(err => {
                    this.showError(err)
                }).then(() => {
                    this.wait = false
                })
            }
        },
        loadNotifications(page = 1) {
            window.scroll(0, 0)
            this.wait = true
            this.clear()
            this.$http.get('/notifications?page=' + page).then(res => {
                this.notifications = res.data.data
            }).catch(err => {
                this.showError(err)
            }).then(() => {
                this.wait = false
            })
        },
        markAsRead(i) {
            this.selected_id = i.id
            this.reading = true
            this.$http.post('/notifications', {id: i.id}).then(() => {
                let index = this.notifications.data.findIndex(a => a.id === i.id)
                this.notifications.data[index].read_at = new Date()
            }).catch().then(() => {
                this.reading = false
            })
        }
    }
}
</script>

<style scoped>
.notification {
    flex-basis: 49% !important;
    border: 1px dotted #ddd
}

.notification:hover {
    cursor: pointer;
    transition: .2s all;
    background-color: #f5f5f5;
}

@media only screen and (max-width: 480px) {
    .notification {
        flex-basis: 100% !important;
    }
}
</style>